import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=011a35d7&"
import script from "./FormSection.vue?vue&type=script&lang=js&"
export * from "./FormSection.vue?vue&type=script&lang=js&"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=011a35d7&prod&module=true&lang=scss&"
import style1 from "./FormSection.vue?vue&type=style&index=1&id=011a35d7&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports